<script setup lang="ts">
  import { computed } from 'vue';
  import { useRouter } from 'vue-router';
  import { usePermission } from '@/entities/Permission';
  import { TabsMenu } from '@/shared/ui';

  const router = useRouter();
  const { can } = usePermission();
  const currentRoute = computed(() => router.currentRoute.value.path);
  const canReadGeneralNotifications = can('readGeneral', 'Notification');

  const selectedOption = computed(
    () => currentRoute.value.split('/').pop() || 'minhas-notificacoes'
  );

  const handleOptionSelect = (optionId: string) => {
    router.push(`/notificacao/${optionId}`);
  };

  const OPTIONS = computed(() => {
    const options = [
      {
        id: 'minhas-notificacoes',
        text: 'Minhas Notificações',
      },
    ];

    if (canReadGeneralNotifications.value) {
      options.push({
        id: 'notificacoes-gerais',
        text: 'Notificações Gerais',
      });
    }

    return options;
  });
</script>

<template>
  <div
    data-testid="notification-page"
    class="pt-4 p-6"
  >
    <h1 class="text-2xl font-bold mb-6">
      Notificações
    </h1>

    <TabsMenu
      :options="OPTIONS"
      :selected-option="selectedOption"
      class="mb-6"
      @option-selected="handleOptionSelect"
    />
    <router-view />
  </div>
</template>
